import { SVGProps } from "react";

const PicPayIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        fill={props.fill || "#000"}
        width="25"
        height="22"
        viewBox="0 0 25 22"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.963 0.586975V8.12397H24.5V0.586975H16.963ZM18.219 1.84298H23.244V6.86798H18.219V1.84298ZM19.475 3.09898V5.61198H21.988V3.09898H19.475ZM4.27 4.35498V7.52997H7.646C9.788 7.52997 11.004 8.56997 11.004 10.469C11.004 12.416 9.788 13.48 7.646 13.48H4.269L4.27 7.52997H0.5V21.414H4.269V16.654H7.839C12.172 16.654 14.654 14.302 14.654 10.334C14.654 6.56297 12.172 4.35598 7.84 4.35598L4.27 4.35498Z"
            fill={props.fill || "#000"}
        />
    </svg>
);

export default PicPayIcon;
